import { useEffect, useState } from "react"
import { supabase } from "@/lib/supabase"

interface ServiceStatus {
  name: string
  status: "operational" | "degraded" | "down"
}

export function ExecutiveHeader() {
  const [time, setTime] = useState(new Date())
  const [adminEmail, setAdminEmail] = useState("")
  const [services] = useState<ServiceStatus[]>([
    { name: "Stripe",   status: "operational" },
    { name: "Supabase", status: "operational" },
    { name: "API",      status: "operational" },
  ])

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 30000)
    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    supabase.auth.getUser().then(({ data }) => {
      setAdminEmail(data.user?.email ?? "")
    })
  }, [])

  const isDev = import.meta.env.DEV

  const statusColor = (s: ServiceStatus["status"]) =>
    s === "operational" ? "#16A34A" : s === "degraded" ? "#D97706" : "#DC2626"

  const statusDot = (s: ServiceStatus["status"]) => (
    <span style={{
      display: "inline-block",
      width: 6, height: 6,
      borderRadius: "50%",
      background: statusColor(s),
      marginRight: 4,
      verticalAlign: "middle",
    }} />
  )

  return (
    <div style={{
      background: "#1E1B4B",
      borderBottom: "1px solid rgba(255,255,255,0.08)",
      padding: "6px 24px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: 11,
      color: "rgba(255,255,255,0.6)",
      fontFamily: "Inter, system-ui, sans-serif",
      letterSpacing: "0.03em",
      flexWrap: "wrap",
      gap: 8,
    }}>
      {/* Left — service status */}
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        {services.map(s => (
          <span key={s.name} style={{ display: "flex", alignItems: "center" }}>
            {statusDot(s.status)}
            {s.name}: <span style={{ color: statusColor(s.status), marginLeft: 3, fontWeight: 600 }}>
              {s.status.charAt(0).toUpperCase() + s.status.slice(1)}
            </span>
          </span>
        ))}
      </div>

      {/* Right — environment, time, user */}
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        {isDev && (
          <span style={{
            background: "#D97706",
            color: "white",
            padding: "1px 8px",
            borderRadius: 4,
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: "0.1em",
          }}>
            DEV
          </span>
        )}
        {!isDev && (
          <span style={{
            background: "#16A34A",
            color: "white",
            padding: "1px 8px",
            borderRadius: 4,
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: "0.1em",
          }}>
            PRODUCTION
          </span>
        )}
        <span>
          Last refresh: {time.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", timeZoneName: "short" })}
        </span>
        {adminEmail && (
          <span style={{ color: "rgba(255,255,255,0.8)", fontWeight: 500 }}>
            {adminEmail}
          </span>
        )}
      </div>
    </div>
  )
}